import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Dropdown,
  Checkbox,
  Button,
  Input,
  Radio
} from 'semantic-ui-react'

const CardORRegistrationAreaUX = (props: any) => {
    return(
      <div
        id="CardORRegistrationArea"
        style={{ margin: "15px", padding: "20px", backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardORRegistrationAreaUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "OR Registration Area" : "OR Registration Area"}
          </label>
          <Label
            color={props.statusColor}
            id="CardORRegistrationAreaUX-Label-3"
            style={{ float: "right" }}>
            {props.PreOperationSequence?.orRegistrationAreaData?.status}
          </Label>
          <hr
            id="CardORRegistrationAreaUX-hr-4">
          </hr>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-5"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-14"
            style={{ display: "flex", width: "50%" , alignItems: "center"}}>
            
            <label
              id="CardORRegistrationAreaUX-label-8"
              style={{ fontWeight: "bold", margin: "5px 10px 0px 0px" , width: "30%"}}>
              {props.languageUX === "en" ? "Type of Case" : "ประเภทเคส"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-47">
              {props.PreOperationSequence?.orRegistrationAreaData?.data?.order_type_label}
            </label>
          </div>
          <div
            id="CardORRegistrationAreaUX-div-13"
            style={{ display: "flex", width: "50%", alignItems: "center" }}>
            
            <div
              id="CardORRegistrationAreaUX-div-58"
              style={{ fontWeight: "bold", margin: "5px 10px" }}>
              
              <label
                id="CardORRegistrationAreaUX-label-48">
                {props.languageUX === "en" ? "Transfer By" : "ส่งตัวโดย"}
              </label>
              <label
                id="CardORRegistrationAreaUX-label-49"
                style={{ color: "red" }}>
                *
              </label>
            </div>
            <Dropdown
              id="CardORRegistrationAreaUX-Dropdown-11"
              name="transfer_by"
              onChange={props.onChangeData}
              options={props.masterOptions?.arriveStatus || []}
              selection={true}
              style={{ width: "70%" }}
              value={props.PreOperationSequence?.orRegistrationAreaData?.data?.transfer_by}>
            </Dropdown>
          </div>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-15"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-16"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Type of Surgeon" : "ประเภทแพทย์ผ่าตัด"}
          </label>
          <Dropdown
            id="CardORRegistrationAreaUX-Dropdown-50"
            name="type_surgeon"
            onChange={props.onChangeData}
            options={props.masterOptions?.orProcedureType || []}
            selection={true}
            style={{ width: "35%" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.type_surgeon || ""}>
          </Dropdown>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-51"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-57"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-52">
              {props.languageUX === "en" ? "Patient identification" : "การยืนยันตัวผู้ป่วย"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-56"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_verbally}
            id="CardORRegistrationAreaUX-Checkbox-53"
            label={props.languageUX === "en" ? "ด้วยวาจา" : "Verbally"}
            name="is_verbally"
            onChange={props.onChangeData}
            style={{ fwidth: "10%", margin: "5px 10px 0px 0px" }}>
          </Checkbox>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_name_band}
            id="CardORRegistrationAreaUX-Checkbox-54"
            label={props.languageUX === "en" ? "สายรัดข้อมือผู้ป่วย" : "Name band"}
            name="is_name_band"
            onChange={props.onChangeData}
            style={{ width: "10%", margin: "5px 10px", minWidth: "max-content" }}>
          </Checkbox>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_chart}
            id="CardORRegistrationAreaUX-Checkbox-55"
            label={props.languageUX === "en" ? "ข้อมูลในชาร์ต" : "Chart"}
            name="is_chart"
            onChange={props.onChangeData}
            style={{ fmargin: "5px 10px" }}>
          </Checkbox>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-64"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-65"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-66">
              {props.languageUX === "en" ? "Mark site Confirm" : "ยืนยันตำแหน่งหัตถการ"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-67"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Radio
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === "yes"}
            id="CardORRegistrationAreaUX-Radio-113"
            label={props.languageUX === "en" ? "ใช่" : "Yes"}
            name="mark_site_confirm"
            onChange={props.onChangeData}
            style={{ width: "10%", margin: "5px 10px 0px 0px" }}
            value="yes">
          </Radio>
          <Radio
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === "no"}
            id="CardORRegistrationAreaUX-Radio-114"
            label={props.languageUX === "en" ? "ไม่" : "No"}
            name="mark_site_confirm"
            onChange={props.onChangeData}
            style={{width: "10%", margin: "5px 10px 0px 0px" }}
            value="no">
          </Radio>
          <Radio
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === "na"}
            id="CardORRegistrationAreaUX-Radio-115"
            label={props.languageUX === "en" ? "ไม่มีข้อมูล" : "N/A"}
            name="mark_site_confirm"
            onChange={props.onChangeData}
            style={{  width: "10%", margin: "5px 10px 0px 0px" }}
            value="na">
          </Radio>
          <Input
            id="CardORRegistrationAreaUX-Input-117"
            name="mark_site"
            onChange={props.onChangeData}
            style={{ width: "45%", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === "na" ? "" : "none" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-71"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-72"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-73">
              {props.languageUX === "en" ? "Procedure Confirm" : "ยืนยันการทำหัตถการ"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-74"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_procedure_confirm}
            id="CardORRegistrationAreaUX-Checkbox-76"
            label={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_procedure_confirm ? "YES" : "NO"}
            name="is_procedure_confirm"
            onChange={props.onChangeData}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-77"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-78"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-79">
              {props.languageUX === "en" ? "Consent Form" : "เอกสารยินยอม"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-80"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_consent_form}
            id="CardORRegistrationAreaUX-Checkbox-81"
            label={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_consent_form ? "YES" : "NO"}
            name="is_consent_form"
            onChange={props.onChangeData}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-82"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-83"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-84">
              {props.languageUX === "en" ? "NPO" : "NPO"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-85"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_npo}
            id="CardORRegistrationAreaUX-Checkbox-86"
            label={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_npo ? "YES" : "NO"}
            name="is_npo"
            onChange={props.onChangeData}
            toggle={true}>
          </Checkbox>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-87"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-88"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-89">
              {props.languageUX === "en" ? "Valuable" : "ทรัพย์สินส่วนตัว"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-90"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable}
            id="CardORRegistrationAreaUX-Checkbox-91"
            label={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable ? "YES" : "NO"}
            name="is_valuable"
            onChange={props.onChangeData}
            style={{ marginRight: "10px" }}
            toggle={true}>
          </Checkbox>
          <Dropdown
            clearable={true}
            id="CardORRegistrationAreaUX-Dropdown-118"
            multiple={true}
            name="valuable"
            onChange={props.onChangeData}
            options={props.masterOptions?.orValuable || []}
            search={true}
            selection={true}
            style={{ width: "45%", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable ? "" : "none" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.valuable || []}>
          </Dropdown>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-92"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-93"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardORRegistrationAreaUX-label-94">
              {props.languageUX === "en" ? "Implant" : "การปลูกถ่าย"}
            </label>
            <label
              id="CardORRegistrationAreaUX-label-95"
              style={{ color: "red" }}>
              *
            </label>
          </div>
          <Checkbox
            checked={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant}
            id="CardORRegistrationAreaUX-Checkbox-96"
            label={props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant ? "YES" : "NO"}
            name="is_impant"
            onChange={props.onChangeData}
            style={{ marginRight: "10px" }}
            toggle={true}>
          </Checkbox>
          <Input
            id="CardORRegistrationAreaUX-Input-116"
            name="implant"
            onChange={props.onChangeData}
            style={{ width: "45%", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant ? "" : "none" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.implant || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-97"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-98"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Lab Data" : "ผลตรวจทางห้องปฏิบัติการ"}
          </label>
          <label
            id="CardORRegistrationAreaUX-label-112">
            {props.PreOperationSequence?.orRegistrationAreaData?.data?.lab_data}
          </label>
          <Button
            icon="list"
            id="CardORRegistrationAreaUX-Button-99"
            onClick={props.onShowLabData}
            size="mini">
          </Button>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-100"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-101"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Lab Remark" : "หมายเหตุทางห้องปฏิบัติการ"}
          </label>
          <Input
            id="CardORRegistrationAreaUX-Input-102"
            name="lab_remark"
            onChange={props.onChangeData}
            style={{ width: "50%" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.lab_remark || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-103"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-104"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Blood" : "เลือด"}
          </label>
          <Input
            id="CardORRegistrationAreaUX-Input-105"
            name="blood"
            onChange={props.onChangeData}
            style={{ width: "50%" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.blood || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-106"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-107"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Imaging Test" : "การตรวจวินิจฉัยรังสีวิทยา"}
          </label>
          <Input
            id="CardORRegistrationAreaUX-Input-108"
            name="imaging"
            onChange={props.onChangeData}
            style={{ width: "50%" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.imaging || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-109"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <label
            id="CardORRegistrationAreaUX-label-110"
            style={{ fontWeight: "bold", width: "15%", margin: "5px 10px 0px 0px" }}>
            {props.languageUX === "en" ? "Remark" : "หมายเหตุ"}
          </label>
          <Input
            id="CardORRegistrationAreaUX-Input-111"
            name="remark"
            onChange={props.onChangeData}
            style={{ width: "50%" }}
            value={props.PreOperationSequence?.orRegistrationAreaData?.data?.remark || ""}>
          </Input>
        </div>
        <div
          id="CardORRegistrationAreaUX-div-59"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardORRegistrationAreaUX-div-60"
            style={{ display: "flex", float: "right" }}>
            
            <div
              id="CardORRegistrationAreaUX-div-119">
              {props.buttonSave}
            </div>
            <div
              id="CardORRegistrationAreaUX-div-120">
              {props.buttonConfirm}
            </div>
            <div
              id="CardORRegistrationAreaUX-div-122">
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardORRegistrationAreaUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationArea"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\", padding: \"20px\", backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "OR Registration Area",
          "valueEN": "OR Registration Area"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทเคส",
          "valueEN": "Type of Case"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"5px 10px 0px 0px\" , width: \"30%\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Dropdown",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Dropdown-11"
        },
        "name": {
          "type": "value",
          "value": "transfer_by"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.arriveStatus || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"70%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.transfer_by"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"50%\", alignItems: \"center\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", width: \"50%\" , alignItems: \"center\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทแพทย์ผ่าตัด",
          "valueEN": "Type of Surgeon"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-16"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.order_type_label"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-47"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งตัวโดย",
          "valueEN": "Transfer By"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-48"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Dropdown-50"
        },
        "name": {
          "type": "value",
          "value": "type_surgeon"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orProcedureType || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"35%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.type_surgeon || \"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "การยืนยันตัวผู้ป่วย",
          "valueEN": "Patient identification"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-52"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Checkbox",
      "parent": 51,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_verbally"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-53"
        },
        "label": {
          "type": "value",
          "value": "Verbally",
          "valueEN": "ด้วยวาจา"
        },
        "name": {
          "type": "value",
          "value": "is_verbally"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ fwidth: \"10%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Checkbox",
      "parent": 51,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_name_band"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-54"
        },
        "label": {
          "type": "value",
          "value": "Name band",
          "valueEN": "สายรัดข้อมือผู้ป่วย"
        },
        "name": {
          "type": "value",
          "value": "is_name_band"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10%\", margin: \"5px 10px\", minWidth: \"max-content\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Checkbox",
      "parent": 51,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_chart"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-55"
        },
        "label": {
          "type": "value",
          "value": "Chart",
          "valueEN": "ข้อมูลในชาร์ต"
        },
        "name": {
          "type": "value",
          "value": "is_chart"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ fmargin: \"5px 10px\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", margin: \"5px 10px\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", float: \"right\" }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันตำแหน่งหัตถการ",
          "valueEN": "Mark site Confirm"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-66"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-67"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันการทำหัตถการ",
          "valueEN": "Procedure Confirm"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-73"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-74"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "Checkbox",
      "parent": 71,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_procedure_confirm"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-76"
        },
        "label": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_procedure_confirm ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_procedure_confirm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "เอกสารยินยอม",
          "valueEN": "Consent Form"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-79"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Checkbox",
      "parent": 77,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_consent_form"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-81"
        },
        "label": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_consent_form ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_consent_form"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "NPO",
          "valueEN": "NPO"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-84"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 83,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Checkbox",
      "parent": 82,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_npo"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-86"
        },
        "label": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_npo ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_npo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "ทรัพย์สินส่วนตัว",
          "valueEN": "Valuable"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-89"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Checkbox",
      "parent": 87,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-91"
        },
        "label": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_valuable"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "การปลูกถ่าย",
          "valueEN": "Implant"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-94"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "label",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-95"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Checkbox",
      "parent": 92,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Checkbox-96"
        },
        "label": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_impant"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ผลตรวจทางห้องปฏิบัติการ",
          "valueEN": "Lab Data"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-98"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Button",
      "parent": 97,
      "props": {
        "icon": {
          "type": "value",
          "value": "list"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Button-99"
        },
        "onClick": {
          "type": "code",
          "value": "props.onShowLabData"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุทางห้องปฏิบัติการ",
          "valueEN": "Lab Remark"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-101"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-102"
        },
        "name": {
          "type": "value",
          "value": "lab_remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.lab_remark || \"\""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-103"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือด",
          "valueEN": "Blood"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-104"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-105"
        },
        "name": {
          "type": "value",
          "value": "blood"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.blood || \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจวินิจฉัยรังสีวิทยา",
          "valueEN": "Imaging Test"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "Input",
      "parent": 106,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-108"
        },
        "name": {
          "type": "value",
          "value": "imaging"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.imaging || \"\""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 109,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ",
          "valueEN": "Remark"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-110"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", width: \"15%\", margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Input",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-111"
        },
        "name": {
          "type": "value",
          "value": "remark"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.remark || \"\""
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.lab_data"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-label-112"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Radio",
      "parent": 64,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === \"yes\""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Radio-113"
        },
        "label": {
          "type": "value",
          "value": "Yes",
          "valueEN": "ใช่"
        },
        "name": {
          "type": "value",
          "value": "mark_site_confirm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"10%\", margin: \"5px 10px 0px 0px\" }"
        },
        "value": {
          "type": "value",
          "value": "yes"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Radio",
      "parent": 64,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === \"no\""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Radio-114"
        },
        "label": {
          "type": "value",
          "value": "No",
          "valueEN": "ไม่"
        },
        "name": {
          "type": "value",
          "value": "mark_site_confirm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{width: \"10%\", margin: \"5px 10px 0px 0px\" }"
        },
        "toggle": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "value",
          "value": "no"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Radio",
      "parent": 64,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === \"na\""
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Radio-115"
        },
        "label": {
          "type": "value",
          "value": "N/A",
          "valueEN": "ไม่มีข้อมูล"
        },
        "name": {
          "type": "value",
          "value": "mark_site_confirm"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"10%\", margin: \"5px 10px 0px 0px\" }"
        },
        "value": {
          "type": "value",
          "value": "na"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Input",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-116"
        },
        "name": {
          "type": "value",
          "value": "implant"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"45%\", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.is_impant ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.implant || \"\""
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Input",
      "parent": 64,
      "props": {
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Input-117"
        },
        "name": {
          "type": "value",
          "value": "mark_site"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"45%\", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site_confirm === \"na\" ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.mark_site || \"\""
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Dropdown",
      "parent": 87,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-Dropdown-118"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "valuable"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orValuable || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"45%\", display: props.PreOperationSequence?.orRegistrationAreaData?.data?.is_valuable ? \"\" : \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.PreOperationSequence?.orRegistrationAreaData?.data?.valuable || []"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardORRegistrationAreaUX-div-122"
        }
      },
      "seq": 122,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardORRegistrationAreaUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
